import { BeneficiaryDTO, BeneficiaryFiltersDTO, FilterTemplateDTO, SortOption } from '../dtos/beneficiary'
import { RequestPayload, ResponseData, ResponseDataWithPagination, SuccessResponseDTO } from '../dtos/generic'
import { defineRoute } from './new-helpers'

type Request = RequestPayload<{
  filters: BeneficiaryFiltersDTO
  sortOption: SortOption
  page: number
  perPage: number
}>

type Response = ResponseDataWithPagination<BeneficiaryDTO[]>

export const BeneficiariesFiltersRoutes = {
  search: defineRoute<'POST', Response, Request>({
    path: `/organizations/:organizationId/beneficiaries/filters`,
  }),
  exportToCsv: defineRoute<
    'POST',
    ResponseData<{ csv: string }>,
    RequestPayload<{
      filters: BeneficiaryFiltersDTO
      sortOption: SortOption
      columnIds: string[]
    }>
  >({
    path: `/organizations/:organizationId/beneficiaries/filters/export-csv`,
  }),
}

export const BeneficiariesFilterTemplatesRoutes = {
  getAll: defineRoute<'GET', ResponseData<FilterTemplateDTO[]>>({
    path: `/organizations/:organizationId/beneficiaries/filter-templates`,
  }),

  createOne: defineRoute<
    'POST',
    ResponseData<FilterTemplateDTO>,
    RequestPayload<Pick<FilterTemplateDTO, 'name' | 'filters'>>
  >({
    path: `/organizations/:organizationId/case-workers/:caseWorkerId/beneficiaries/filter-templates/create`,
  }),

  deleteOne: defineRoute<'DELETE', ResponseData<SuccessResponseDTO>>({
    path: `/organizations/:organizationId/case-workers/:caseWorkerId/beneficiaries/filter-templates/:filterTemplateId/delete`,
  }),

  updateOne: defineRoute<
    'PATCH',
    ResponseData<FilterTemplateDTO>,
    RequestPayload<Pick<FilterTemplateDTO, 'name' | 'filters'>>
  >({
    path: `/organizations/:organizationId/case-workers/:caseWorkerId/beneficiaries/filter-templates/:filterTemplateId/update`,
  }),
}

export const AdminBeneficiariesFiltersRoutes = {
  search: defineRoute<'POST', Response, Request>({
    path: `/organizations/:organizationId/admin/beneficiaries/filters`,
  }),
  exportToCsv: defineRoute<
    'POST',
    ResponseData<{ csv: string }>,
    RequestPayload<{
      filters: BeneficiaryFiltersDTO
      sortOption: SortOption
      columnIds: string[]
    }>
  >({
    path: `/organizations/:organizationId/admin/beneficiaries/filters/export-csv`,
  }),
}
